module.exports = __webpack_public_path__ + "img/DAG structure.af92df19.svg";